<template>
  <div class="gov-course-list">
    <!-- <div class="header">
      <div class="search-box">
        <div class="search-title">线上精品课程</div>
        <div class="search-input">
          <el-input placeholder="请输入内容" v-model="serachInWords">
            <template slot="append">搜索</template>
</el-input>
<el-row gutter="10" style="margin-top: 5px">
  <div v-for="(item, index) in searchWordsData" :key="index" style="margin-left: 15px;">
    <el-col span="xs">
      <div class="words-select">{{ item.name }}</div>
    </el-col>
  </div>
</el-row>
</div>
</div>
    </div>-->

    <div class="container">
      <!-- <div class="breadcrumb">
        <div
          class="flex"
          style="align-items: center;margin-bottom: 18px;padding-top: 18px;"
        >
          <span style="font-size: 14px;">当前位置：</span>
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item
              style="cursor: pointer;"
              :to="{ name: 'talentService' }"
              >人才服务</el-breadcrumb-item
            >
            <el-breadcrumb-item style="color: #009999"
              >课程列表</el-breadcrumb-item
            >
          </el-breadcrumb>
        </div>
      </div>-->
      <div class="keyWords">
        <div class="box-con">
          <div class="box-con-title">全部分类：</div>
          <div
            class="box-con-btn"
            :class="curIndex === '' ? 'btn-select' : 'btn-normal'"
            @click="searchList('')"
          >
            <div class="box-con-title">全部</div>
          </div>
          <div
            v-for="(item, index) in CourseTypeList"
            :key="index"
            class="box-con-btn"
            :class="curIndex === item.subjectId ? 'btn-select' : 'btn-normal'"
            @click="searchList(item.subjectId)"
          >
            <div class="box-con-title">{{ item.subjectName }}</div>
          </div>
        </div>
      </div>

      <div class="container">
        <div
          :class="dataList.length > 0 ? 'gov-course' : 'gov-course-loading'"
          v-loading="listLoading"
        >
          <el-row>
            <div v-for="(item, index) in dataList" :key="index" @click="onClickDetail(item)">
              <el-col style="width: 20%" class="course-list-item-box">
                <div class="item-out-box">
                  <div
                    class="course-list-img"
                    :style="{
            backgroundImage: `url(${'https://static.zhuzaocloud.com' +
              item.logo})`,
          }"
                  ></div>
                  <div class="content-title">{{ item.courseName }}</div>
                  <div class="course-item-info">
                    <div class="course-hour-icon"></div>
                    <div class="content-cases">共{{ item.kpointNum }}节</div>
                    <div class="course-duration-icon"></div>
                    <div
                      class="content-link-method"
                    >{{ item.courseMinutes }}分{{ item.courseSeconds }}秒</div>
                  </div>

                  <div style="padding-left: 10px;color: #2d50a1;font-size:14px">免费</div>
                </div>
              </el-col>
            </div>
          </el-row>
        </div>
        <div style="text-align: center; padding: 30px 0">
          <el-pagination
            @current-change="onChangeCurrent"
            :current-page="params.current"
            :page-size="params.pageSize"
            background
            layout="prev, pager, next"
            :total="params.total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { getCourseType, getCourseList } from "../../utils/interface";
export default {
  data() {
    return {
      params: {
        status: 1,
        rec: 1,
        current: 1,
        pageSize: 10,
        subjectId: "",
        courseName: "",
        total: 0
      },

      listLoading: true,
      serachInWords: "",
      CourseTypeList: [],

      priceArangeStart: "",
      priceArangeEnd: "",

      dataList: [],

      srtWordsData: [
        { name: "关注度" },
        { name: "最新" },
        { name: "价格" },
        { name: "价格区间" }
      ],

      searchWordsData: [
        { name: "基础知识" },
        { name: "金属成型" },
        { name: "机械加工" },
        { name: "水泵装配" },
        { name: "水泵测试" }
      ],
      curIndex: "", //当前位置
      allSearch: false // 是否全局搜索
    };
  },
  watch: {
    /* 监听全局搜索的title变化 */
    "$route.query.title"(val) {
      if (val) {
        this.allSearch = true;
        this.getCourseListBySearch();
      }
    }
  },
  mounted() {
    if (this.$route.query.title) {
      this.allSearch = true;
      this.getCourseListBySearch();
    } else {
      this.getCourseType();
    }
  },
  created() {},
  methods: {
    // 获取课程分类列表
    getCourseType() {
      getCourseType().then(res => {
        if (res.data && res.data.length > 0) {
          this.CourseTypeList = res.data;
          this.getCourseList(""); // 默认展示第一类服务商的信息
        } else {
          this.CourseTypeList = [];
        }
      });
    },
    // 全局搜索查询
    getCourseListBySearch() {
      getCourseType().then(res => {
        if (res.data && res.data.length > 0) {
          this.CourseTypeList = res.data;
          this.getCourseList("", this.$route.query.title); // 默认展示第一类服务商的信息
        } else {
          this.CourseTypeList = [];
        }
      });
    },
    // 根据课程分类id获取课程列表
    getCourseList(subjectId, courseName) {
      this.listLoading = true;
      getCourseList({
        current: this.params.current,
        pageSize: "10",
        subjectId: subjectId,
        courseName: courseName || ""
      })
        .then(res => {
          this.listLoading = false;
          if (res.list && res.list.length > 0) {
            this.dataList = res.list;
            this.params.total = res.total;
          } else {
            this.dataList = [];
          }
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    ...mapMutations(["searchTypeVuex", "searchMsgVuex"]),
    searchList(subjectId) {
      this.allSearch = false;
      this.searchTypeVuex("6");
      this.searchMsgVuex("");
      this.$router.push({
        path: "/onlineCourseList",
        query: {
          title: ""
        }
      });
      this.curIndex = subjectId;
      this.getCourseList(subjectId);
    },
    onClickDetail(val) {
      let routeData = this.$router.resolve({
        path: "/onlineCourseDetail",
        query: {
          courseId: val.courseId,
          type: "course",
          titleName: "在线精品课程详情",
          titleForm: "onlineCourseDetail"
        }
      });
      window.open(routeData.href, "_blank");
    },
    onClickSort(val) {
      this.params.stage = val.name;
      //  this.getDataList()
    },
    onChangeCurrent(e) {
      this.params.current = e;
      if (this.allSearch) {
        this.getCourseList("", this.$route.query.title);
      } else {
        this.getCourseList();
      }
    }
  }
};
</script>
<style scoped lang="less">
@basic-colors: #009999;

.gov-course-list {
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    /* background-color: #2d50a1; */
    color: #fff;
    background-color: #2d50a1;
  }

  // background: rgb(245 245 245);
  background: #ffffff;

  // padding-top: 20px;
  .header {
    height: 100px;
    background: #ffffff;
    display: flex;
    align-items: baseline;
    padding-bottom: 5px;

    .search-box {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      margin-top: 30px;

      .search-title {
        display: flex;
        align-items: center;
        font-size: 25px;
        font-weight: 1000;
        width: 156px;
      }

      .search-input {
        margin: auto;
        width: 681px;

        .words-select {
          cursor: pointer;
          color: #6e6e6e;
          font-size: 14px;
        }

        /deep/ .el-input-group--append .el-input__inner {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
          border-end-start-radius: 25px;
          border-start-start-radius: 25px;
        }

        /deep/ .el-input-group__append,
        .el-input-group__prepend {
          background-color: #2d50a1;
          color: #ffffff;
          vertical-align: middle;
          display: table-cell;
          position: relative;
          border: 1px solid #dcdfe6;
          border-start-end-radius: 25px;
          border-end-end-radius: 25px;
          padding: 0 20px;
          width: 1px;
          white-space: nowrap;
        }
      }
    }
  }

  .breadcrumb {
    width: 1200px;
    margin: 0 auto;
    background: #ffffff;
    margin-top: 10px;
    border-bottom: 1px solid #ccc;
  }

  .keyWords {
    // padding-top: 9px;
    font-size: 16px;
    background: #ffffff;
    font-weight: 600;

    .box-con {
      display: flex;

      .box-con-title {
        white-space: nowrap;
        padding-top: 2px;
        padding-bottom: 2px;
        padding-left: 10px;
        padding-right: 10px;
      }

      .box-con-btn {
        margin-left: 17px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;

        .box-con-title {
          white-space: nowrap;
          padding-top: 2px;
          padding-bottom: 2px;
          padding-left: 10px;
          padding-right: 10px;
        }
      }

      .btn-normal {
        color: #000;
        background-color: #ffffff;
      }

      .btn-select {
        color: #fff;
        background-color: #2646a4;
        border-radius: 5px;
        text-align: center;
        white-space: nowrap;
      }
    }

    .sort-rules-normal {
      width: 75px;
      text-align: center;

      &:hover {
        cursor: pointer;
      }
    }

    .sort-rules-select {
      width: 75px;
      text-align: center;
      background: #2d50a1;

      &:hover {
        cursor: pointer;
      }
    }

    /deep/.btn-box > .el-button--small {
      padding: 4px 15px;
      font-size: 12px;
      border-radius: 3px;
    }

    /deep/ .jiage-box > .el-input__inner {
      height: 23px;
    }
  }

  .container {
    width: 1300px;
    margin: 0 auto;
    margin-top: 40px;

    .gov-course {
      margin-top: 20px;

      .item-out-box {
        width: 240px;
        height: 275px;
        // box-shadow: 0 0 9px #6f6c6c;
        // border-radius: 16px;
        border: 1px solid #efefef;
        cursor: pointer;
        margin-bottom: 14px;

        .course-list-img {
          background-repeat: no-repeat;
          background-size: 100% 100%;
          width: 240px;
          height: 180px;
          margin-bottom: 0px !important;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          transition: all 0.3s;

          // border-top-left-radius: 16px;
          // border-top-right-radius: 16px;
          &:hover {
            transform: scale(1.02);
          }
        }

        .content-title {
          padding-top: 10px;
          padding-bottom: 10px;
          font-size: 14px;
          font-weight: 400;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          padding-left: 11px;

          &:hover {
            color: #2d50a1;
          }
        }

        .course-item-info {
          display: flex;
          align-items: center;

          .course-hour-icon {
            background-image: url(../../assets/publicService/talentService/edit.png);
            width: 12px;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            height: 12px;
            margin-left: 13px;
          }

          .course-duration-icon {
            background-image: url(../../assets/publicService/talentService/video-player.png);
            width: 12px;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            height: 12px;
            margin-left: 45px;
          }
        }

        .content-cases {
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 14px;
          padding-top: 5px;
          padding-bottom: 5px;
          color: #918484;
          margin-left: 4px;
        }

        .content-link-method {
          overflow: hidden;
          white-space: nowrap;
          font-size: 14px;
          padding-top: 5px;
          padding-bottom: 5px;
          color: #918484;
          margin-left: 4px;
        }
      }
    }

    .gov-course-loading {
      height: 578px;
    }
  }
}

.gov-course-list-loading {
  height: 724px;
}
</style>



// WEBPACK FOOTER //
// src/components/talentServices/onlineCourseList.vue